import { render, staticRenderFns } from "./CustomLogin.vue?vue&type=template&id=2b746b2e"
import script from "./CustomLogin.vue?vue&type=script&lang=js"
export * from "./CustomLogin.vue?vue&type=script&lang=js"
import style0 from "./CustomLogin.vue?vue&type=style&index=0&id=2b746b2e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports